import { enqueueSnackbar } from 'notistack';
import { useCallback } from 'react';

import { useTranslations } from './use-translations';

export const useCopyToClipboard = () => {
  const t = useTranslations('notify.clipboard');

  return useCallback(
    async (value: string) => {
      let success = true;

      try {
        await navigator.clipboard.writeText(value);
      } catch (err) {
        try {
          const textarea = document.createElement('textarea');

          textarea.value = value;
          textarea.style.top = '0';
          textarea.style.left = '0';
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';

          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();

          success = document.execCommand('copy');

          document.body.removeChild(textarea);
        } catch (err) {
          success = false;
        }
      }

      if (success) {
        enqueueSnackbar(t('copyToClipboard', { value }), {
          variant: 'success',
        });
      } else {
        enqueueSnackbar(t('copyToClipboardError'), {
          variant: 'error',
        });
      }
    },
    [t]
  );
};
